const UAParser = require('ua-parser-js')

const BROWSER_NAMES = {
  safari: {
    desktop: 'Safari',
    mobile: 'Mobile Safari',
  },
  internetExplorer: {
    desktop: 'IE',
    mobile: 'IEMobile',
  },
}

const OS_NAMES = {
  ios: 'iOS',
}

export class UserAgent {
  private static readonly _userAgentParser = new UAParser()
  private static readonly _browser = this._userAgentParser.getBrowser()
  private static readonly _os = this._userAgentParser.getOS()

  static readonly browserName: undefined | string = this._browser.name
  static readonly browserVersion: number = parseInt(this._browser.version ?? '')
  static readonly osName: undefined | string = this._os.name

  static readonly browserIsInternetExplorer: boolean =
    this.browserName === BROWSER_NAMES.internetExplorer.desktop ||
    this.browserName === BROWSER_NAMES.internetExplorer.mobile

  static readonly browserIsSafari: boolean =
    this.browserName === BROWSER_NAMES.safari.desktop ||
    this.browserName === BROWSER_NAMES.safari.mobile

  static readonly osIsIOS: boolean = this.osName === OS_NAMES.ios
}
